<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:00em; padding-top:15px; ">To Lynne, Gary and Nicky for everything, particularly their support writing this book in the first place. Their suggestions and corrections at various stages were invaluable.</p>
<p style="text-indent:00em; padding-top:15px; ">To Martin and Carole Scrowston for sharing many adventures without which, there would not be this book to write.</p>
<p style="text-indent:00em; padding-top:15px; ">The same goes for the rest of family and friends who also have a mutual passion for life and adventure.</p>
<p style="text-indent:00em; padding-top:15px; ">Thanks to Audrey Salkeld (General Editor of World Mountaineering) for inspiration and allowing me to use a few words from ‘unwritten codes’</p>
<p style="text-indent:00em; padding-top:15px; ">Thanks to Corrie Jeffery (Digital conversions specialist) for her excellent digitising work on my photographs and slides.</p>
<p style="text-indent:00em; padding-top:15px; ">To the UK’s Air, Land and Sea rescue services who without them, people like me may not have been around to write a book.</p>
<p style="text-indent:00em; padding-top:15px; ">Finally, I am grateful to Austin Macauley for taking me on and giving me the opportunity to publish my memoir.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?5c3fd7f9